import InlineButton from './InlineButton'
import InlineLink from './InlineLink'
import InlineBadge from './InlineBadge'
import InlineCode from './InlineCode'
import InlineHeading from './InlineHeading'
import InlineImage from './InlineImage'

export { InlineButton, InlineLink, InlineBadge, InlineCode, InlineHeading, InlineImage }

// Component registry for dynamic component loading
export const getInlineComponent = (componentType) => {
  const componentMap = {
    button: InlineButton,
    link: InlineLink,
    badge: InlineBadge,
    code: InlineCode,
    heading: InlineHeading,
    image: InlineImage,
  }

  return componentMap[componentType] || null
}

// Available component types for validation
export const INLINE_COMPONENT_TYPES = ['button', 'link', 'badge', 'code', 'heading', 'image']
